<script setup lang="ts">
import type { FooterLinkSocial } from '../..';

const links: FooterLinkSocial[] = [
  {
    text: 'Instagram',
    url: 'https://www.instagram.com/okgym.cz/',
    icon: { name: 'icon:instagram', size: 'sm' },
  },
  {
    text: 'Facebook',
    url: 'https://www.facebook.com/people/OK-GYM-Pardubice/100094511462626/',
    icon: { name: 'icon:facebook', size: 'md' },
  },
  {
    text: 'TikTok',
    url: 'https://www.tiktok.com/@okgym_cz',
    icon: { name: 'icon:tiktok', size: 'md' },
  },
];
</script>

<template>
  <FooterContentSection heading="Sledujte nás">
    <div class="gap-r3 flex flex-col items-start">
      <FooterContentSocialsLink v-for="(link, i) in links" :key="i" :link />
    </div>
  </FooterContentSection>
</template>
